import { NUM_FIRST_OPTIONS_SHOWN } from 'ui-forms-components/constants/OptionsTable';
export const handleShowingOptions = ({
  formField: {
    options = [],
    selectedOptions = []
  },
  showAllOptions = false,
  setOptions = () => {},
  setSelectedOptions = () => {}
}) => {
  if (options.length) {
    if (!showAllOptions && options.length > NUM_FIRST_OPTIONS_SHOWN) {
      setOptions(options.slice(0, NUM_FIRST_OPTIONS_SHOWN));
    } else {
      setOptions([...options]);
    }
  }
  setSelectedOptions([...selectedOptions]);
};